const initialState = {
    message: '',
    open: false,
};

const skipSuccessActions = [
    'ISSUE_SUCCESS',
    'ISSUE_ATTACHMENT_SUCCESS',
    'ISSUE_COMMENTS_SUCCESS',
    'APM_CAMERA_RECORDING_DOWNLOAD_SUCCESS',
    'APM_CAMERA_STREAM_SUCCESS',
    'LOGS_SUCCESS',
    'LOGS_LIST_SUCCESS',
    'UPDATE_ENVIRONMENT_SUCCESS',
    'UPDATE_MONITORING_SUCCESS',
    'FORCE_CLOSE_APM_CAMERA_STREAMS_SUCCESS',
    'SC_CONNECTION_SUCCESS',
];
const skipFailureActions = [
    'JIRA_ISSUE_CHECKLIST_FAILURE',
    'UPDATE_ENVIRONMENT_FAILURE',
    'IMPORT_SPARE_PART_ARTICLES_FAILURE',
    'APM_CAMERA_STREAM_FAILURE',
    'DELIVERY_APM_REQUEST_FAILURE',
    'DELIVERY_APM_FAILURE',
    'SC_CONNECTION_FAILURE',
    'SC_CONNECTION_REQUEST_FAILURE',
];

function reducer(state = initialState, action) {
    /**
     * SPECIFIC ACTIONS
     */

    if (action.type === 'SNACKBAR_CLOSE' || action.type === 'AUTHENTICATE_SUCCESS') {
        return { ...state, open: false };
    }

    if (action.type === 'SNACKBAR_OPEN' && action.payload.data && action.payload.data.message) {
        return {
            ...state,
            message: action.payload.data.message,
            open: true,
            type: action.payload.type || state.type,
        };
    }

    if (action.type === 'SHOW_APM_PROVISION_SUCCESS_MESSAGE') {
        return { ...state, message: { id: 'actions.provisioned' }, open: true, type: 'success' };
    }

    if (action.type === 'SHOW_APM_PROVISIONING_EDIT_ERROR_MESSAGE') {
        return {
            ...state,
            message: { id: 'error.apmProvisioningInProgress' },
            open: true,
            type: 'error',
        };
    }

    if (action.type === 'UPDATE_APM_PROVISION_FIELDS_SUCCESS') {
        return { ...state, message: { id: 'actions.verified' }, open: true, type: 'success' };
    }

    if (action.type === 'SHOW_MAINTENANCE_STARTED_MESSAGE') {
        return {
            ...state,
            message: { id: 'apm.rct.maintenance.started' },
            open: true,
            type: 'success',
        };
    }

    if (action.type === 'SHOW_MAINTENANCE_ENDED_MESSAGE') {
        return {
            ...state,
            message: { id: 'apm.rct.maintenance.ended' },
            open: true,
            type: 'success',
        };
    }

    if (action.type === 'APM_CAMERAS_FAILURE' && action.payload.code === 'ECONNABORTED') {
        return {
            ...state,
            message: { id: 'apm.rct.liveStreams.cameras.noResponse' },
            open: true,
            type: 'error',
        };
    }

    if (
        action.type === 'SERVER_TYPE_SUCCESS' &&
        action.requestParams &&
        ['put'].includes(action.requestParams.method)
    ) {
        return { ...state, open: false };
    }

    if (
        action.type === 'SERVER_TYPE_CONTROL_TOOL' &&
        action.requestParams &&
        ['put'].includes(action.requestParams.method)
    ) {
        return { ...state, open: false };
    }

    if (
        (action.type === 'SERVER_CONTROL_TOOL_EXECUTE_SUCCESS' ||
            action.type === 'SERVER_CONTROL_TOOL_EXECUTE_FAILURE') &&
        action.requestParams &&
        ['post'].includes(action.requestParams.method)
    ) {
        return { ...state, open: false };
    }

    if (action.type === 'START_APM_PROVISION_SUCCESS') {
        return {
            ...state,
            message: { id: 'apm.provision.queued' },
            open: true,
            type: 'success',
        };
    }

    /**
     * GENERAL ACTIONS
     */

    if (
        action.type.slice(-8) === '_SUCCESS' &&
        action.requestParams &&
        action.requestParams.method === 'delete'
    ) {
        return { ...state, message: { id: 'snackbar.deleted' }, open: true, type: 'success' };
    }

    if (
        !skipSuccessActions.includes(action.type) &&
        action.type.slice(-8) === '_SUCCESS' &&
        action.requestParams &&
        ['put', 'patch', 'post'].includes(action.requestParams.method)
    ) {
        return { ...state, message: { id: 'snackbar.saved' }, open: true, type: 'success' };
    }

    if (
        !skipFailureActions.includes(action.type) &&
        action.type.slice(-8) === '_FAILURE' &&
        action.payload
    ) {
        let message = action.payload.response?.data?.message || action.payload.message;
        if (action.payload.code === 'ECONNABORTED') {
            message = {
                id: 'error.request_timeout',
                values: { url: action.requestParams.url?.replace(/(\?.+)/, '') },
            };
        } else if (message === 'No message available') {
            message = { id: 'snackbar.error.unknown' };
        } else if (typeof message === 'string') {
            if (message.startsWith('Invalid values for fields')) {
                message = { id: 'error.wrong_data' };
            }
        }

        return {
            ...state,
            message,
            open: true,
            type: 'error',
        };
    }

    if (action.type === 'ISSUE_CREATION_SUCCESS') {
        return {
            ...state,
            message: { id: 'customer.requests.thankYou' },
            open: true,
            type: 'success',
        };
    }

    return state;
}

export default reducer;
